module.exports = __webpack_public_path__ + "files/6da8390b9d2bfc941e66fb456948c7fc.png";